<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-card class="mb-2">
            <div class="d-flex align-items-center">
                <div @click="$router.push('/customers')" class="border-right pr-1 pointer">
                    <div class="text-center mb-50">
                        <feather-icon icon="ArrowRightIcon" size="26" />
                    </div>
                    <div style="font-size: 13px;">بازگشت</div>
                </div>
                <div class="px-1">
                    <h5 class="d-flex align-items-center font-weight-bolder mb-50">
                        <span v-if="customer.firstName">
                            {{ customer.firstName }}
                        </span>
                        <span v-if="customer.lastName" class="ml-50">{{ customer.lastName }}</span>
                    </h5>
                    <h5 class="mb-0">{{ customer.phoneNumber }}</h5>
                </div>
            </div>
        </b-card>
        <b-card v-if="ordersList.length" class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="ordersList" :fields="fields" class="mb-0" striped>
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                    <template #cell(type)="data">
                        <div v-if="data.item.type == 0">داخل سالن</div>
                        <div v-if="data.item.type == 1">بیرون بر</div>
                    </template>
                    <template #cell(paymentMethod)="data">
                        <div v-if="data.item.paymentMethod == 0">نقدی</div>
                        <div v-if="data.item.paymentMethod == 1">کارت</div>
                        <div v-if="data.item.paymentMethod == 2">درگاه</div>
                        <div v-if="data.item.paymentMethod == 3">واریز به حساب</div>
                        <div v-if="data.item.paymentMethod == 255">ترکیبی</div>
                    </template>
                    <template #cell(orderList)="data">
                        <feather-icon @click="showOrderList(data.item)" icon="ShoppingBagIcon" class="text-info pointer"
                            size="21" />
                    </template>
                    <template #cell(payableAmount)="data">
                        {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-card v-else class="text-center pt-5 pb-4">
            موردی وجود ندارد
        </b-card>
        <b-pagination align="center" @input="ordersCustomer" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />

        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>
                <invoiceDetail :orderDetails="orderDetails" />
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay } from 'bootstrap-vue';
import { storeService } from '@core/services';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        invoiceDetail
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            ordersList: [],
            fields: [
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'paymentMethod',
                    label: 'نوع پرداخت',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'orderList',
                    label: 'جزئیات',
                },

            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
            },
            customer: {
                id: null,
                lastName: null,
                firstName: null,
                phoneNumber: null
            },
            storeId: null,
            orderDetails: {},
        }
    },
    methods: {
        showOrderList(order) {
            this.orderDetails = order
            this.$bvModal.show('show-order-list')
        },
        ordersCustomer() {
            this.loading = true
            storeService.ordersCustomer(this.storeId, this.customer.id, this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.customer.firstName = data.firstName
                this.customer.lastName = data.lastName
                this.customer.phoneNumber = data.phoneNumber
                this.ordersList = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
    },
    mounted() {
        this.customer.id = this.$route.query.id ? this.$route.query.id : 0;
        this.storeId = localStorage.getItem("storeId")
        this.ordersCustomer()
    },
};
</script>